import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  selector: 'email-feature-request-created-template',
  styleUrls: ['../../global-styles.less', './feature_request_created.component.less'],
  templateUrl: './feature_request_created.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailInfoboxComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class FeatureRequestCreatedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<FeatureRequestCreatedTemplateData>;
}

export type FeatureRequestCreatedTemplateData = {
  title: string;
  p1_html: string;
  note_body: string;
  button_link: string;
  button_text: string;
  avatar_url: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const FeatureRequestCreatedTemplateMocks: FeatureRequestCreatedTemplateData[] = [
  {
    title: 'Integration request',
    p1_html:
      'Olivia Nowak wants to start using <b>Dropbox Sign</b>. Go to Recruitee to review this integration request.',
    note_body: 'Hi Boss! Can you please integrate Dropbox Sign for me? I’ll need it this week.',
    button_link: 'https://recruitee.com/',
    button_text: 'View request',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    footer: {
      text: 'Need help?',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      label: 'Contact us',
      target: '_blank',
    },
  },
];
